<div class="resource-group-summary">
  <div *ngIf="!selection" class="arm-summary">0 Items selected</div>
  <div *ngIf="selection" class="arm-summary">
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span [title]="selection.name" class="arm-summary-value" fxFlex>{{selection.name}}</span>
    </div>
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Type:</span>
      <span [title]="selection.displayType" class="arm-summary-value" fxFlex>{{selection.displayType}}</span>
    </div>
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Elements:</span>
      <span [title]="selection.name" class="arm-summary-value" fxFlex>{{selection.displayElements}}</span>
    </div>

    <ng-container *ngIf="selection.callsQuotaId">
      <div class="arm-summary-item" fxLayout="row">
        <span class="arm-summary-name">Calls quota:</span>
      </div>

      <div class="arm-summary-section">

        <div class="arm-summary-item" fxLayout="row">
          <span class="arm-summary-name" fxFlex="45">Quota name:</span>
          <span [title]="selection.callsQuotaName" class="arm-summary-value"
                fxFlex> {{selection.callsQuotaName}} </span>
        </div>

        <div class="arm-summary-item" fxLayout="row">
          <span class="arm-summary-name" fxFlex="45">Calls duration (minutes):</span>
          <span [title]="selection.callsDuration || '0'" class="arm-summary-value"
                fxFlex> {{selection.callsDuration || '0'}} </span>
        </div>

        <div class="arm-summary-item" fxLayout="row">
          <span class="arm-summary-name" fxFlex="45">Outgoing calls:</span>
          <span class="arm-summary-value" fxFlex>
                <i *ngIf="selection.quotaState === 'UNBLOCK'" class="fa fa-check summary-value-green"></i>
                <i *ngIf="selection.quotaState === 'BLOCK_OUTGOING'" class="fa fa-times summary-value-red"></i>
              </span>
        </div>

        <div class="arm-summary-item" fxLayout="row">
          <span class="arm-summary-name" fxFlex="45">Warning threshold reached:</span>
          <span class="arm-summary-value" fxFlex>
                 <span *ngIf="selection.quotaWarningReached" class="arm-summary-value-red">Yes</span>
                <span *ngIf="!selection.quotaWarningReached" class="arm-summary-value-green">No</span>
              </span>
        </div>

        <div class="arm-summary-item" fxLayout="row">
          <span class="arm-summary-name" fxFlex="45">Quota reached:</span>
          <span class="arm-summary-value" fxFlex>
                  <span *ngIf="selection.quotaLimitReached" class="arm-summary-value-red">Yes</span>
                <span *ngIf="!selection.quotaLimitReached" class="arm-summary-value-green">No</span>
              </span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
